import forEach from '../../../../javascripts/dom/forEach';

const selects = document.querySelectorAll('[data-js-module="a-select"]');

const init = async () => {
  const { default: Select } = await import(/* webpackChunkName: "a-select" */ './select');

  forEach(selects, (index, element) => {
    new Select(element);
  });
};

if (selects.length) init();
